import { render, staticRenderFns } from "./ShipAssigner.vue?vue&type=template&id=4907069f&scoped=true&"
import script from "./ShipAssigner.vue?vue&type=script&lang=js&"
export * from "./ShipAssigner.vue?vue&type=script&lang=js&"
import style0 from "./ShipAssigner.vue?vue&type=style&index=0&id=4907069f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4907069f",
  null
  
)

export default component.exports